import ContentCopyIcon from '@material-design-icons/svg/filled/content_copy.svg?react';
import ExpandMoreIcon from '@material-design-icons/svg/filled/expand_more.svg?react';
import type { ReactNode } from 'react';

interface CollapsibleSectionProps {
  title: string;
  isExpanded: boolean;
  onToggle: () => void;
  onCopy?: () => void;
  collapsedSummary?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function CollapsibleSection({
  title,
  isExpanded,
  onToggle,
  onCopy,
  collapsedSummary,
  children,
  className = '',
}: CollapsibleSectionProps) {
  return (
    <div
      className={`overflow-hidden rounded-lg border border-neutral-700/50 bg-neutral-800/30 ${className}`}
    >
      <div className="flex items-center gap-1 pr-2 text-sm">
        <button
          type="button"
          onClick={onToggle}
          aria-expanded={isExpanded}
          className="flex min-h-11 min-w-0 flex-1 items-center gap-2 px-4 py-2 text-left font-semibold text-white transition-colors hover:bg-neutral-800/40"
        >
          <ExpandMoreIcon
            aria-hidden="true"
            className={`size-4 shrink-0 fill-current text-neutral-400 transition-transform ${
              isExpanded ? 'rotate-180' : ''
            }`}
          />
          <span className="truncate">{title}</span>
          {!isExpanded && collapsedSummary && (
            <span className="ml-auto shrink-0 pl-2 text-xs font-normal text-neutral-500">
              {collapsedSummary}
            </span>
          )}
        </button>
        {onCopy && (
          <button
            type="button"
            onClick={onCopy}
            className="rounded-md p-2 text-neutral-400 transition-colors hover:bg-neutral-700/50 hover:text-white"
            title="Copy to clipboard"
            aria-label="Copy to clipboard"
          >
            <ContentCopyIcon className="size-4 fill-current" />
          </button>
        )}
      </div>
      {isExpanded && (
        <div className="border-t border-neutral-700/40 p-4">{children}</div>
      )}
    </div>
  );
}
